export enum EventsFlowActionNodeTypes {
  SendToUrl = 'send-to-url',
  SendCaregiverNote = 'send-caregiver-note',
  SendPatientNote = 'send-patient-note',
  TranscribeCallRecording = 'transcribe-call-recording',
}
